export default "__VITE_PUBLIC_ASSET__20be1812__"